import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreMaterialModule } from '@nttp/core-material';
import { MatSelectHybridComponent } from './mat-select-hybrid.component';
import { MatSelectSearchComponent } from './mat-select-search/mat-select-search.component';

@NgModule({
  declarations: [
    MatSelectHybridComponent,
    MatSelectSearchComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CoreMaterialModule
  ],
  exports: [
    MatSelectHybridComponent,
    MatSelectSearchComponent
  ]
})

export class MatSelectHybridModule { }
